import { Box, Grid, GridItem, Icon, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import {
  FaCar,
  FaUser,
  FaFileInvoiceDollar,
  FaClipboardList,
  FaMoneyCheckAlt,
} from "react-icons/fa";
import { MdPendingActions } from "react-icons/md";
import BreadCrumbMaker from "../../components/BreadCrumbMaker";
import { useContext } from "react";
import { AuthContext } from "../../providers/AuthValidationLayer";
import { Globe } from "lucide-react";

const Management = () => {
  const { hasPermission } = useContext(AuthContext);
  const cardData = [
    {
      id: 1,
      title: "Vehicle Segments",
      icon: FaCar,
      link: "/management/vehicles",
      bgColor: "#FFF5D9",
      color: "#FFBB38",
      permission: { heading: "Operations Setup", subHeading: "Vehicle Segments" },
    },
    // {
    //   id: 2,
    //   title: "Customer",
    //   icon: FaUser,
    //   link: "/management/customer",
    //   bgColor: "#E7EDFF",
    //   color: "#396AFF",
    //   permission: { heading: "Operations Setup", subHeading: "Customer" },
    // },
    // {
    //   id: 3,
    //   title: "Taxes",
    //   icon: FaFileInvoiceDollar,
    //   link: "/management/taxes",
    //   bgColor: "#FFE0EB",
    //   color: "#FF82AC",
    //   permission: { heading: "Operations Setup", subHeading: "Taxes" },
    // },
    // {
    //   id: 8,
    //   title: "Custom Booking",
    //   icon: FaMoneyCheckAlt,
    //   link: "/management/custom-booking",
    //   bgColor: "#DCFAF8",
    //   color: "#00B69B",
    //   permission: { heading: "Operations Setup", subHeading: "Custom Booking" },
    // },
    {
      id: 4,
      title: "Tour Package Management",
      icon: FaClipboardList,
      link: "/management/packages",
      bgColor: "#E7EDFF",
      color: "#396AFF",
      permission: { heading: "Operations Setup", subHeading: "Tour Package Management" },
    },
    {
      id: 5,
      title: "State Tax List",
      icon: FaFileInvoiceDollar,
      link: "/management/taxes",
      bgColor: "#FFE0EB",
      color: "#FF82AC",
      permission: { heading: "Operations Setup", subHeading: "State Tax List" },
    },
    {
      id: 6,
      title: "Terms and Conditions",
      icon: MdPendingActions,
      link: "/management/terms-and-conditions",
      bgColor: "#ffe9e2",
      color: "#ff8542",
      permission: { heading: "Operations Setup", subHeading: "Terms and Conditions" },
    },
    {
      id: 7,
      title: "Global Custom Fields",
      icon: Globe,
      link: "/management/global-fields",
      bgColor: "#ffe9e2",
      color: "#ff8542",
      permission: { heading: "Operations Setup", subHeading: "Vehicle Segments" },
    },
  ];

  return (
    <Box px={4} py={6}>
      <BreadCrumbMaker
        items={[{ link: "#", title: "Operations Setup", on: true }]}
      />
      <Grid
        templateColumns={{
          base: "repeat(1, 1fr)",
          sm: "repeat(2, 1fr)",
          md: "repeat(3, 1fr)",
        }}
        gap={6}
      >
        {cardData
          .filter((card) =>
            hasPermission(
              card.permission.heading,
              card.permission.subHeading,
              "GET",
            ),
          )
          .map((card) => (
            <GridItem key={card.id}>
              <Link to={card.link}>
                <Box
                  bg="white"
                  p={4}
                  textAlign="center"
                  display="flex"
                  flexDirection="row"
                  justifyContent="flex-start"
                  alignItems="center"
                  h="120px"
                  gap={2}
                  borderRadius="3xl"
                  border="1px solid #D0D5DD"
                  borderColor="gray.200"
                  transition="all 0.2s ease"
                  _hover={{
                    borderColor: "blue.400",
                    boxShadow: "md",
                    transform: "translateY(-2px)",
                  }}
                >
                  <Box
                    bg={card.bgColor}
                    w={18}
                    h={18}
                    p={30}
                    mx={4}
                    // mb={4}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    borderRadius="full"
                  >
                    <Icon as={card.icon} boxSize={6} color={card.color} />
                  </Box>
                  <Text fontSize="16px" fontWeight="semibold" color="gray.500">
                    {card.title}
                  </Text>
                </Box>
              </Link>
            </GridItem>
          ))}
      </Grid>
    </Box>
  );
};

export default Management;
